import api from './api';

export const getProjects = (status) => api.get('/projects/', { params: status ? { status } : {} });

export const getProject = (id) => api.get(`/projects/${id}`);

export const createProject = (data) => api.post('/projects/', data);

export const updateProject = (id, data) => api.put(`/projects/${id}`, data);

export const setProjectStatus = (id, status) => api.put(`/projects/${id}/status`, { status });

export const cancelProject = (id) => api.delete(`/projects/${id}`);

export const getProjectPunchPoints = (id) => api.get(`/projects/${id}/punch-points`);

export const getProjectDelays = (id) => api.get(`/projects/${id}/delays`);

export const getProjectProgress = (id, { month, startDate, endDate, includeSubProjects } = {}) =>
  api.get(`/projects/${id}/progress`, {
    params: {
      ...(startDate || endDate ? { start_date: startDate, end_date: endDate } : month ? { month } : {}),
      ...(includeSubProjects ? { include_sub_projects: true } : {}),
    },
  });

export const getProjectStages = (id) => api.get(`/projects/${id}/stages`);

export const getProductionSummary = ({ startDate, endDate, status } = {}) =>
  api.get('/projects/production-summary', {
    params: {
      ...(startDate ? { start_date: startDate } : {}),
      ...(endDate ? { end_date: endDate } : {}),
      ...(status ? { status } : {}),
    },
  });
